import { renderReactApp, updateReactApp } from './renderer';
import defineCustomElement from './createElement';
import { FabricComponent } from './fabricComponent';

export const setupCustomElement = () =>
    defineCustomElement(
        renderReactApp,
        updateReactApp,
        (instance: FabricComponent) => {
            // Anything custom that we want to run after boostraping the app
            instance.dispatchEvent(new Event('fabric-component-app:rendered'));
        }
    );
